/**
 * @generated SignedSource<<4286923cfffdeb079d5abd921a2ca6ce>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ViewerGateQuery$variables = Record<PropertyKey, never>;
export type ViewerGateQuery$data = {
  readonly whoami: {
    readonly permissions: ReadonlyArray<{
      readonly action: string;
      readonly object: string;
    }>;
  };
};
export type ViewerGateQuery = {
  response: ViewerGateQuery$data;
  variables: ViewerGateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CurrentUser",
    "kind": "LinkedField",
    "name": "whoami",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ObjectPermission",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "action",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "object",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewerGateQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ViewerGateQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "077020a7d4414c047f0dee03047aa04d",
    "id": null,
    "metadata": {},
    "name": "ViewerGateQuery",
    "operationKind": "query",
    "text": "query ViewerGateQuery {\n  whoami {\n    permissions {\n      action\n      object\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cbf7526af23e32eb4ec318e5bac3f9e3";

export default node;
